<mat-card>
  <mat-progress-bar mode="indeterminate" *ngIf="isLoading"></mat-progress-bar>

  <div class="toolbar">
    <mat-form-field appearance="outline" floatLabel="always" subscriptSizing="dynamic" class="small">
      <mat-label>Filter by</mat-label>
      <mat-select
        [(value)]="filterBy"
        (selectionChange)="onFiltersChanged()"
        [disabled]="!!selectedSpace"
      >
        <mat-option value="lastSeen">Last seen</mat-option>
        <mat-option value="createdAt">Joined</mat-option>
      </mat-select>
    </mat-form-field>

    <mat-form-field appearance="outline" floatLabel="always" subscriptSizing="dynamic" class="small">
      <mat-label>Timeframe</mat-label>
      <mat-select
        [(value)]="selectedTimeframe"
        (selectionChange)="onFiltersChanged()"
        [disabled]="!!selectedSpace"
      >
        <mat-option *ngFor="let timeframe of timeframeOptions" [value]="timeframe">
          {{ timeframe.name }}
        </mat-option>
      </mat-select>
    </mat-form-field>

    <mat-form-field
      appearance="outline"
      floatLabel="always"
      subscriptSizing="dynamic"
      class="small space-field"
    >
      <mat-label>Spaces</mat-label>
      <input
        matInput
        type="text"
        placeholder="Type a space name"
        [formControl]="spaceQuery"
        [matAutocomplete]="spaceAuto"
      />
      <button
        *ngIf="selectedSpace"
        matSuffix
        mat-icon-button
        type="button"
        class="field-clear"
        aria-label="Show all members again"
        title="Show all members again"
        (click)="clearSpace(); $event.stopPropagation()"
      >
        <mat-icon>close</mat-icon>
      </button>
      <mat-icon matSuffix aria-hidden="true" *ngIf="!selectedSpace">expand_more</mat-icon>
      <mat-autocomplete
        #spaceAuto="matAutocomplete"
        [displayWith]="spaceLabel"
        (optionSelected)="onSpacePicked($event.option.value)"
        (closed)="syncSpaceField()"
        class="space-auto"
      >
        <mat-optgroup label="Show on the map" *ngIf="filteredLayers.length">
          <mat-option *ngFor="let option of filteredLayers" [value]="option">
            {{ option.name }}
          </mat-option>
        </mat-optgroup>
        <mat-optgroup label="Only one space's members, newest first">
          <mat-option *ngFor="let row of filteredSpaces" [value]="row">
            <span class="space-opt">
              <span class="space-opt__title">{{ row.title }}</span>
              <span class="space-opt__meta">
                {{ pickedDate(row) }} · {{ row.memberCount }} member{{ row.memberCount === 1 ? '' : 's' }}<span
                  *ngIf="!row.located"
                > · no pin</span>
              </span>
            </span>
          </mat-option>
          <mat-option *ngIf="moreSpaces" disabled>
            {{ moreSpaces }} more · type to narrow
          </mat-option>
          <mat-option *ngIf="!filteredSpaces.length" disabled>No space by that name</mat-option>
        </mat-optgroup>
      </mat-autocomplete>
    </mat-form-field>

    <mat-form-field
      appearance="outline"
      floatLabel="always"
      subscriptSizing="dynamic"
      class="small member-field"
    >
      <mat-label>Find a member</mat-label>
      <mat-icon matPrefix aria-hidden="true">search</mat-icon>
      <input
        matInput
        type="text"
        placeholder="Name, company or city"
        [formControl]="memberQuery"
        [matAutocomplete]="memberAuto"
      />
      <button
        *ngIf="memberLabel(memberQuery.value)"
        matSuffix
        mat-icon-button
        type="button"
        class="field-clear"
        aria-label="Clear the search"
        title="Clear the search"
        (click)="clearMemberSearch(); $event.stopPropagation()"
      >
        <mat-icon>close</mat-icon>
      </button>
      <mat-autocomplete
        #memberAuto="matAutocomplete"
        [displayWith]="memberLabel"
        (optionSelected)="onMemberPicked($event.option.value)"
        class="member-auto"
      >
        <mat-option *ngFor="let m of memberResults" [value]="m">
          <span class="member-opt">
            <img
              class="member-opt__face"
              *ngIf="m.photo; else initials"
              [src]="m.photo"
              alt=""
              referrerpolicy="no-referrer"
            />
            <ng-template #initials>
              <span class="member-opt__face member-opt__face--initials">
                {{ (m.firstName || '?')[0] }}{{ (m.lastName || '')[0] }}
              </span>
            </ng-template>
            <span class="member-opt__text">
              <span class="member-opt__name">{{ memberLabel(m) }}</span>
              <span class="member-opt__meta">{{ memberLine(m) }}</span>
            </span>
          </span>
        </mat-option>
        <mat-option
          *ngIf="noMemberMatch"
          disabled
          >Nobody with a location matches</mat-option
        >
      </mat-autocomplete>
    </mat-form-field>

    <button
      mat-stroked-button
      type="button"
      class="reset-button"
      *ngIf="hasFilters"
      (click)="resetFilters()"
    >
      <mat-icon>restart_alt</mat-icon>
      Reset filters
    </button>

    <mat-slide-toggle
      color="primary"
      [(ngModel)]="showChats"
      (change)="onChatsToggled()"
      >Chat links</mat-slide-toggle
    >
  </div>

  <div class="strip">
    <span class="chip" *ngIf="selectedSpace">
      <mat-icon aria-hidden="true">groups</mat-icon>
      Members of {{ selectedSpace.title }}
      <span class="chip__note" *ngIf="selectedSpace.locationSource === 'address'"
        >· pin placed from its address</span
      >
      <span class="chip__note" *ngIf="!isLoading && selectedSpace.lat == null"
        >· no location on record</span
      >
      <button type="button" class="chip__clear" (click)="clearSpace()">Clear</button>
    </span>

    <span class="stat"><b>{{ members.length | number }}</b> on the map</span>
    <span class="stat" *ngIf="truncated">
      newest {{ members.length | number }} of {{ located | number }}
    </span>
    <span class="stat" *ngIf="unlocated > 0">
      <b>{{ unlocated | number }}</b> without a location
    </span>
    <span class="stat"><i class="dot dot--online"></i><b>{{ onlineCount }}</b> online now</span>
    <span class="stat" [title]="'Ring colour: joined in the last ' + newWindowLabel"
      ><i class="dot dot--new"></i><b>{{ newCount }}</b> joined in the last {{ newWindowLabel }}</span
    >
    <span class="stat" *ngIf="spaceWindow || selectedSpace">
      <i class="dot dot--space"></i><b>{{ pinnedSpaces }}</b> spaces<span
        *ngIf="selectedTimeframe.value && !selectedSpace && shownSpaces.length < spaces.length"
      >
        with members on the map</span
      >
    </span>
    <span class="stat" *ngIf="chatLinks">
      <i class="line line--recent"></i><b>{{ chatLinks.length }}</b> chat links
      <i class="line line--old"></i>older than 30 days
    </span>
    <span class="stat" *ngIf="chatLinks && selectedSpace?.lat != null">
      space lines hidden while chat links are on
    </span>
  </div>

  <mat-card-content>
    <app-map
      [members]="members"
      [spaces]="shownSpaces"
      [chatLinks]="chatLinks"
      [selectedSpaceId]="selectedSpace?.id ?? null"
      [newWithinMs]="newWithinMs"
      (spaceSelected)="onSpaceSelected($event)"
      (spaceCleared)="clearSpace()"
      (chatLinkClicked)="onChatLinkClicked($event)"
      (viewChanged)="onViewChanged($event)"
      [initialView]="initialView"
    ></app-map>
  </mat-card-content>
</mat-card>
